export default __webpack_public_path__ + "static/media/edit_welcome_email.d1574a92.png";